"use client"

import { CultureInfoTitle } from "@/entities/culture/list/ui/CultureInfoTitle"

import { TitleBox } from "./_html"

export const CultureInfoListTitle = () => {

    return (
        <>
            <TitleBox>
                <CultureInfoTitle/>
            </TitleBox>
        </>
    )
}
